var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"enter-class":"opacity-0","leave-to-class":"opacity-0"}},[(_vm.show && _vm.isPageDisabled)?[_c('cookie-banner',{on:{"confirm":_vm.confirm}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }